/* eslint-disable import/first */
// Polyfill `process` for amazon-cognito-identity-js in webpack 4
if (typeof (window as any).process === 'undefined') {
    (window as any).process = { env: { NODE_ENV: 'development' } };
}

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from 'presentation/App';
import { getStore } from 'core/managers/state-manager';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { loaderSubscribeInit } from 'presentation/common/services/loader.service';

(async () => {
    let currentStore = await getStore();
    loaderSubscribeInit(currentStore);
    ReactDOM.render(
      <React.StrictMode>
        {/* @ts-ignore react-redux v7 types conflict with @types/react v18 in parent node_modules */}
        <Provider store={currentStore}>
            <App />
        </Provider>
      </React.StrictMode>,
      document.getElementById('root')
    );
    reportWebVitals();
 })();
